export const isAdmin = (u) => u?.role === "admin";
export const isApprover = (u) => u?.role === "manager" || u?.role === "admin";
export const homeFor = (u) => (isApprover(u) ? "/approvals" : "/");
export const ROLE_LABELS = { employee: "Contractor", manager: "Approver", admin: "Admin" };
